import * as React from 'react';

import * as styles from './styles.css';

interface IFloorPlan {
  fullUrl: string;
  polygonPath?: string | null;
  onClick?(): void;
}

export const FloorPlan = ({ fullUrl, polygonPath, onClick }: IFloorPlan) => {
  const image = fullUrl;
  const imageRef = React.useRef<HTMLImageElement | null>(null);
  const [loaded, setLoaded] = React.useState(false);
  const [{ width, height }, setImageSize] = React.useState({ width: 0, height: 0 });

  const handleImageLoaded = React.useCallback(() => {
    const img = imageRef.current;

    /* istanbul ignore else */
    if (img) {
      setLoaded(true);
      setImageSize({
        width: img.naturalWidth,
        height: img.naturalHeight,
      });
    }
  }, []);

  React.useEffect(() => {
    /* istanbul ignore else */
    if (imageRef.current && imageRef.current.complete) {
      handleImageLoaded();
    }
  }, [handleImageLoaded]);

  return (
    <div className={styles['container']} onClick={onClick}>
      <img ref={imageRef} src={image} onLoad={handleImageLoaded} alt="" />
      <svg className={styles['svg']} id="genplan-svg" width="100%" height="100%" viewBox={`0 0 ${width} ${height}`}>
        {loaded && <path fill="var(--accent-main-primary)" d={`M ${polygonPath} Z`} />}
      </svg>
    </div>
  );
};
